import { useTranslation } from 'react-i18next';

import Button from '../../../../../../components/buttons/Button';
import type { MetagameBingoEvent } from '../../../../../../stores/bingo/types';
import { useBingoWidgetCallbacks } from '../../../../hooks';
import { BingoLiveButtonText } from '../../BingoLiveButtonText/BingoLiveButtonText';
import { BingoWidgetLogo } from '../../BingoWidgetLogo/BingoWidgetLogo';
import { BingoWideWidgetWrapper } from '../BingoWideWidgetWrapper/BingoWideWidgetWrapper';

import styles from './BingoLiveWideWidget.module.scss';

interface BingoLiveWideWidgetProps {
  event: MetagameBingoEvent;
}

export function BingoLiveWideWidget(props: BingoLiveWideWidgetProps) {
  const { event } = props;
  const { t } = useTranslation();
  const { onEnterLiveEventClick } = useBingoWidgetCallbacks();
  const feature = event?.game.isFreeDaubEvent ? 'daub' : 'general';
  const bingoType = event?.coinType === 'GC' ? 'CASUAL' : 'SWEEP';

  return (
    <BingoWideWidgetWrapper
      feature={feature}
      wrapperClassName={styles.wrapper}
      onClick={() => onEnterLiveEventClick(event)}
    >
      <BingoWidgetLogo bingoType={bingoType} sizeType="wide" />
      <div className={styles.content}>
        <div className={styles.topWrapper}>
          <span className={styles.text}>
            <span className={bingoType === 'SWEEP' ? styles.textSweep : styles.textCasual}>
              {bingoType === 'SWEEP' ? t('prime.bingo.sweepBingo') : t('prime.bingo.ccBingo')}
            </span>{' '}
            {t('prime.lobbyBanner.isLiveSmall')}
          </span>
        </div>
        <div className={styles.btnWrapper}>
          <Button btnType="purple-blue" className={styles.btn}>
            <BingoLiveButtonText />
          </Button>
        </div>
      </div>
    </BingoWideWidgetWrapper>
  );
}
